<template>
  <div>
    <vue-headful title="Alabama Travel - Accessibility" description="Alabama Travel - Accessibility" url="https://alabama.travel/accessibility" />
    <Banner :bannerId="page.fields.hero_image" type="image" :imageAlt="page.fields.hero_image_alt" :location="page.fields.location" :link="page.fields.link" />
    <h1>{{ page.fields.title }}</h1>
    <section aria-label="accessibility document" class="accessibility" data-swiftype-name="body" data-swiftype-type="text">
      <div v-html="page.fields.content"></div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import Banner from '@/components/Common/Banner.vue';
import Footer from '@/components/Common/Footer.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  components: {
    Banner,
    Footer,
  },
  data() {
    return {
      page: {
        fields: {},
      },
    };
  },
  methods: {
    getPage() {
      butter.page
        .retrieve('*', 'accessibility', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  async created() {
    this.getPage();
  },
})
class AccessibilityPage extends Vue {}

export default AccessibilityPage;
</script>

<style lang="scss" scoped>
.accessibility {
  font-size: 0.8rem;
  margin: 25px;
  text-align: left;

  @media only screen and (min-width: 729px) {
    margin: 50px;
  }

  @media only screen and (min-width: 729px) {
    font-size: 1rem;
    margin-left: 100px;
  }

  h1 {
    margin-bottom: 50px;
    text-align: center;
  }
}
</style>
